import { SignPersonPartEnum } from '@/@types/Contracts';
import { IExport } from '@/@types/Export';

import { httpClient } from '@/config/httpClient';

export async function getExportDebitNote(
  debitNoteId: string,
  exportOption?: string | null,
) {
  const where: Record<string, any> = {
    isActive: true,
    id: debitNoteId,
  };

  return httpClient.get<IExport>(`/debit-note/report/${exportOption}`, {
    params: {
      relations: {
        where,
        include: {
          Customer: true,
          DebitNoteSignChassisInstallments: {
            include: {
              SignChassisInstallments: {
                include: {
                  SignChassis: true,
                },
              },
            },
          },
          Sign: {
            include: {
              SignPerson: {
                where: { part: SignPersonPartEnum.COMPRADOR },
              },
              Deal: {
                select: {
                  Plan: {
                    select: {
                      id: true,
                      title: true,
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  });
}
